import React from "react";

const UsersWithLeaveTable = ({ data }) => {
  return (
    <div>
      <h2>Users with Leave</h2>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Leave Hours</th>
          </tr>
        </thead>
        <tbody>
          {data.map((user, index) => (
            <tr key={index}>
              <td>{user.name}</td>
              <td>{user.leave} hours</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(UsersWithLeaveTable);
